import { makeStyles } from "tss-react/mui-compat"

export const useFiltersFormStyles = makeStyles()(
  (theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(2),
    },
    box: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(1),
    },
    statesAutocompleteRoot: {
      ["& .makeStyles-root-9"]: {
        marginBottom: 0,
      },
    },
    clearAllButton: {
      display: "block",
    },
  }),
)
